import React from "react";
import { withRouter } from "react-router-dom";
import { useQuery } from "react-apollo-hooks";
import {
  STORE_DELIVERY_PRODUCT_CATEGORY_DETAIL_QUERY,
  STORE_DELIVERY_PRODUCT_CATEGORY_LIST_QUERY,
} from "../../Queries";
import Presenter from "./Presenter";

export default withRouter(({ history, match, location }) => {
  const baseUrl = "/delivery/deliveryProducts/categories";

  const { data, loading, error } = useQuery(
    STORE_DELIVERY_PRODUCT_CATEGORY_DETAIL_QUERY,
    {
      variables: { id: match.params.id },
    }
  );

  if (error) {
    return <>{error.message}</>;
  }
  if (loading) {
    return <></>;
  }

  return (
    <Presenter
      history={history}
      match={match}
      location={location}
      data={data}
      baseUrl={baseUrl}
    />
  );
});
